import axios from 'axios';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';

export function deleteLoadSheet(id: number) {
  return {
    type: 'DELETE_LOAD_SHEET',
    payload: axios.delete(`${getNonGwApiRoot()}/distribution/load_sheets/${id}`),
  };
}
